import React from "react";
import Typography from "@common/components/Typography";
import {
  getCurrentSizeProfile,
  responsiveFontSize,
} from "@common/components/Typography/style";

interface TicketPriorityProps {
  priority: TicketsPriorityFilter;
  label: string;
}

const TicketPriority = (props: TicketPriorityProps) => {
  const { priority, label } = props;

  return (
    <Typography
      variant="caption"
      sx={(theme) => ({
        lineHeight: 1,
        color: theme.palette.ticket[priority].main,
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: theme.palette.ticket[priority].main,
        width: "fit-content",
        fontSize: getCurrentSizeProfile().small,
        ...responsiveFontSize(theme, "small"),
        padding: "0.5em",
        borderRadius: "8px",
      })}
    >
      {label}
    </Typography>
  );
};

export default TicketPriority;
